export function isSchedulePast(start: string, now: Date = new Date()): boolean {
  const startTime = new Date(start).getTime();

  if (Number.isNaN(startTime)) {
    return false;
  }

  return startTime < now.getTime();
}
